import PropTypes from 'prop-types';

export const MpgParams = PropTypes.shape({
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
});
